import React from 'react'
import { Table, useMediaSize } from '@ally/metronome-ui'
import { AccountType } from '@ally/data-types-afg-accounts'
import AccountGroup from '../../Shared/AccountGroup'
import AccountCard from '../../Shared/AccountCard'
import { getColumns } from './TableColumns'
import MobileDepositAccountList from '../../Shared/MobileAccountsCard/MobileDepositAccountList'
import AccountCardMbox from '../../Shared/AccountCardMbox'
import { sortDepositAccountsGroup, hasStaleAccounts } from '../../utils'
import { NonPrintingWrapper } from '../../Shared/NonPrintingWrapper'
import { useCustomizeDashboard } from '../../CustomizeDashboard/CustomizeDashboardContext/CustomizeDashboardContext'
import { useAccountTypes } from '../../AccountTypeContext'

const Cds: React.FC = () => {
  const [{ dashboardView }] = useCustomizeDashboard()
  const {
    isBankOutage,
    activeDepositAccounts,
    activeNonRetirementDepositAccounts,
  } = useAccountTypes()
  const hasStaleData = hasStaleAccounts(activeDepositAccounts)
  const cdaAccountsGroup = sortDepositAccountsGroup(
    activeNonRetirementDepositAccounts.filter(
      acc => acc.type === AccountType.CDA,
    ),
  )
  const sortedCdAccounts = [
    ...cdaAccountsGroup.activeAccounts,
    ...cdaAccountsGroup.closedAccounts,
  ]
  const isMdDown = useMediaSize('MdDown')
  const isLgDown = useMediaSize('LgDown')
  const isPrint = window.matchMedia('print').matches

  return (
    <>
      {sortedCdAccounts.length && !isBankOutage ? (
        <AccountGroup name="CDs">
          <AccountCard type="CDA">
            {isMdDown && !isPrint ? (
              <MobileDepositAccountList
                accounts={sortedCdAccounts}
                hasStaleData={hasStaleData}
              />
            ) : (
              <Table
                data={sortedCdAccounts}
                columns={getColumns({
                  view: dashboardView,
                  isLgDown,
                  hasStaleData,
                })}
                captionText="Information about your Ally Bank accounts"
                fullWidth
                suppressMdDownLayout
                withFooter
              />
            )}
            <NonPrintingWrapper>
              <AccountCardMbox name="ally-dashboard-cd-well" />
            </NonPrintingWrapper>
          </AccountCard>
        </AccountGroup>
      ) : null}
    </>
  )
}

export default Cds
